import { DiscountsValidationSchema } from 'features/config/ConfigConditionSchemas'

const validateDiscount = (
  discount: string,
  validation: DiscountsValidationSchema
) => {
  // For now we only support startsWith validation but there could be more in the future

  const lcDiscount = discount.toLowerCase()
  if (validation.startsWith.length > 0) {
    const isValid = validation.startsWith.some((prefix) =>
      lcDiscount.startsWith(prefix.toLowerCase())
    )
    if (!isValid) return false
  }

  return true
}

export default validateDiscount
